module.exports = __webpack_public_path__ + "static/photo_11-d17b238a910835a1649b0b3fd03663cc.jpg";